import { lazy, Suspense, useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';

const LandingPage = lazy(() => import('./components/Landing'));
const ScheduleDemo = lazy(() => import('./components/Landing/ScheduleDemo'));

function App() {
  const { pathname } = useLocation();

  // always scroll to top on route/path change
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth"
    });
  }, [pathname]);

  return (
    <>
      <Suspense fallback={<div className="min-h-screen bg-white flex items-center justify-center">
        <div className="text-gray-600">Loading...</div>
      </div>}>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/schedule-demo" element={<ScheduleDemo />} />
        </Routes>
      </Suspense>
    </>
  );
}

export default App;
